import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import GlobalPattern from "@/components/GlobalPattern";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import OurStoryPage from "@/pages/OurStoryPage";
import JournalPage from "@/pages/JournalPage";
import ShippingReturnsPage from "@/pages/ShippingReturnsPage";
import ContactPage from "@/pages/ContactPage";

const COMING_SOON = process.env.REACT_APP_COMING_SOON === "true";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-background text-foreground relative">
      <GlobalPattern />
      <div className="relative flex flex-col flex-1" style={{ zIndex: 1 }}>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            {COMING_SOON ? (
              /*
                COMING-SOON MODE
                Public visitors see only the landing page.
                Admin / preview routes remain accessible for you to work on the
                full store behind the scenes:
                  /admin       — product & order management
                  /login       — sign in
                  /preview     — the full store home
                  /preview/... — any full store route (shop, product, cart, etc.)
              */
              <Routes>
                <Route path="/" element={<ComingSoonPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route
                  path="/preview"
                  element={
                    <>
                      <Header />
                      <CartDrawer />
                      <main className="flex-1">
                        <HomePage />
                      </main>
                      <Footer />
                    </>
                  }
                />
                <Route
                  path="/preview/shop"
                  element={
                    <>
                      <Header />
                      <CartDrawer />
                      <main className="flex-1">
                        <ShopPage />
                      </main>
                      <Footer />
                    </>
                  }
                />
                <Route
                  path="/preview/product/:id"
                  element={
                    <>
                      <Header />
                      <CartDrawer />
                      <main className="flex-1">
                        <ProductDetailPage />
                      </main>
                      <Footer />
                    </>
                  }
                />
                {[
                  { path: "/preview/our-story", el: <OurStoryPage /> },
                  { path: "/preview/journal", el: <JournalPage /> },
                  { path: "/preview/shipping-returns", el: <ShippingReturnsPage /> },
                  { path: "/preview/contact", el: <ContactPage /> },
                ].map((r) => (
                  <Route
                    key={r.path}
                    path={r.path}
                    element={
                      <>
                        <Header />
                        <CartDrawer />
                        <main className="flex-1">{r.el}</main>
                        <Footer />
                      </>
                    }
                  />
                ))}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            ) : (
              /* Full store mode */
              <>
                <Header />
                <CartDrawer />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/shop" element={<ShopPage />} />
                    <Route path="/product/:id" element={<ProductDetailPage />} />
                    <Route path="/our-story" element={<OurStoryPage />} />
                    <Route path="/journal" element={<JournalPage />} />
                    <Route path="/shipping-returns" element={<ShippingReturnsPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/account" element={<AccountPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="*" element={<HomePage />} />
                  </Routes>
                </main>
                <Footer />
              </>
            )}
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
